<template>
  <div>
    <UiBadge :type="badgeType" :label="eventLabel" />
  </div>
</template>

<script>
import UiBadge from "@/components/ui/Badge"

export default {
  name: "ProfileEventTypeRenderer",
  components: {
    UiBadge
  },
  data: () => ({
      knownEvents: {
        created: 'success',
        updated: 'info',
        deleted: 'warning',
      }
  }),
  props: ["object", "columnKey"],
  computed: {
      eventLabel: function () {
          if(Object.keys(this.knownEvents).includes(this.object[this.columnKey])){
              return window.V.$i18n.t(`reports.logsTable.profileEvents.${this.object[this.columnKey]}`);
          } else {
              return window.V.$i18n.t(`reports.logsTable.profileEvents.default`);
          }
      },
      badgeType: function () { return this.knownEvents[this.object[this.columnKey]] || 'secondary'}
  }
};
</script>
  